import type { RootState } from 'features/app/store/store';
import { selectIsAstSignMailDestinationClaimed } from 'features/ast-signmail/store';
import { selectIsSignMailSessionInProgress } from 'features/signmail/store/';

export type LocalSignMailStartBlockReason =
  | 'ast-claimed'
  | 'session-in-progress';

export const localSignMailStartBlockMessage: Record<
  LocalSignMailStartBlockReason,
  string
> = {
  'ast-claimed':
    'Cannot start local SignMail: AST SignMail destination already claimed.',
  'session-in-progress':
    'Cannot start local SignMail: SignMail session already in progress.',
};

export const getLocalSignMailStartBlockReason = (
  state: RootState
): LocalSignMailStartBlockReason | null => {
  if (selectIsAstSignMailDestinationClaimed(state)) {
    return 'ast-claimed';
  }
  if (selectIsSignMailSessionInProgress(state)) {
    return 'session-in-progress';
  }
  return null;
};

export const canStartLocalSignMailSession = (state: RootState): boolean =>
  getLocalSignMailStartBlockReason(state) === null;
